import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Rating, Stack} from "@mui/material";
import {toast} from "react-toastify";
import {Button, Image} from "antd";
import {MDBBtn, MDBBtnGroup, MDBCard, MDBCardBody, MDBCardImage, MDBCol, MDBRipple, MDBRow} from "mdb-react-ui-kit";
import {baseUrl_back} from "../../api/BaseUrl";
import LightBoxFs from "../LightBoxFs/LightBoxFs";
import Typography from "@mui/material/Typography";

const sources=[
    "http://127.0.0.1:8000/Static/Images/Products/Baff_Biryuzovyy_Kationik_kombi/Main.png",
    "https://ra.co/images/events/flyer/2012/4/fr-0417-360153-18233-front.jpg"
]
const OneProductDetail = (props) => {
   // console.log(props.elm)
    let navigate = useNavigate();

    const [toggler, setToggler] = useState(false);
    const [value, setValue] = React.useState(5);
    const [favorXIcon,setxfavorIcon]= React.useState('Добавить в избранное')
    const [carXticon,setCarticon]= React.useState('Добавить в корзину')
    var defsize="all"
    // if (props.elm.selected_Size!=null){
    //     defsize=props.elm.selected_Size
    // }
    const [currsize, setCurrSize]= React.useState(defsize)



    var favorIcon='Добавить в избранное'
    var carticon=""
    var carticonStyle="success"
    var favoriconStyle="success"
    var sizeColor="light"
    var favor= JSON.parse( localStorage.getItem('favorites'))
    var cart= JSON.parse( localStorage.getItem('cart'))

    if (favor == null)
    {       favor=[]
        localStorage.setItem('favorites',JSON.stringify(favor));
    } else {
        favor= JSON.parse( localStorage.getItem('favorites'))
    }

    if (cart == null)
    {       cart=[]
        localStorage.setItem('cart',JSON.stringify(cart));
    } else {
        cart= JSON.parse( localStorage.getItem('cart'))
    }
    if (cart.filter(elm=>elm.name==props.elm._id).length> 0)
    {
        carticon='Убрать из корзины';
        carticonStyle="danger"
    }
    else
    {
        carticon='Добавить в корзину';
        carticonStyle="success"
    }

    if (favor.filter(elm=>elm.name==props.elm._id).length> 0)
    {
        favorIcon='💗';
        favoriconStyle="danger"
    }
    else
    {
        favoriconStyle="success"
        favorIcon='Добавить в избранное';
    }

    function SetSize(nme)
    {
        setCurrSize(nme)
    }
    function setInFavor()
    {
        if (favor.filter(elm=>elm.name==props.elm._id).length== 0)
        {
            toast.success('Добавлено в избранное', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });

            favor= JSON.parse( localStorage.getItem('favorites'))
            let el={"name": props.elm._id, "size": currsize, "count":1}
            favor.push(el)
            localStorage.setItem('favorites',JSON.stringify(favor));
            props.callbak(favor.length)
            setxfavorIcon('💗')


        }else
        {
            toast.error('Удалено из избранного', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            favor= JSON.parse( localStorage.getItem('favorites'))
            favor = favor.filter((n) => {return n.name != props.elm._id});
            localStorage.setItem('favorites',JSON.stringify(favor));
            props.callbak(favor.length)
            setxfavorIcon('🤍')
        }
    }

    function setInCart()
    {
        if (cart.filter(elm=>elm.name==props.elm._id).length== 0)
        {
            toast.success('Добавлено в корзину', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            cart= JSON.parse( localStorage.getItem('cart'))
            let el={"name": props.elm._id, "size": currsize, "count":1}
            cart.push(el)
            localStorage.setItem('cart',JSON.stringify(cart));
            props.callbak(cart.length)
            setxfavorIcon('1')
        }else
        {
            toast.error('Удалено из корзины', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            cart= JSON.parse( localStorage.getItem('cart'))
            cart = cart.filter((n) => {return n.name != props.elm._id});
            localStorage.setItem('cart',JSON.stringify(cart));
            props.callbak(cart.length)
            setxfavorIcon('2')
        }
    }

    function myttt()
    {
        navigate(props.urlx);
    }
    return (
        <>
            {/*<ToastContainer />*/}
            <MDBRow className="justify-content-center mt-5"  >
                <MDBCol md="12" xl="11">
                    <MDBCard className="shadow-0  rounded-3 mt-2 mb-0 ">
                        <MDBCardBody style={{ backgroundColor: "#382b2f", color:"white" }}>
                            <MDBRow >
                                <MDBCol md="12" lg="3" className="mb-4 mb-lg-0 glass0">
                                    <Stack spacing={2}>
                                    {/*<MDBRipple*/}
                                    {/*    rippleColor="light"*/}
                                    {/*    rippleTag="div"*/}
                                    {/*    className="bg-image rounded hover-zoom hover-overlay "*/}
                                    {/*>*/}
                                    {/*    <MDBCardImage*/}
                                    {/*        src={props.elm.Defimage}*/}
                                    {/*        fluid*/}
                                    {/*        position='center'*/}
                                    {/*        className="h-100"*/}
                                    {/*    />*/}
                                    {/*    <a>*/}
                                    {/*        <div*/}
                                    {/*            onClick={() => setToggler(!toggler)}*/}
                                    {/*            className="mask"*/}
                                    {/*            style={{ backgroundColor: "rgba(251, 251, 251, 0.15)" }}*/}
                                    {/*        ></div>*/}
                                    {/*    </a>*/}
                                    {/*</MDBRipple>*/}
                                        <Image
                                            // width={200}
                                            className="h-100"
                                            src={props.elm.Defimage}
                                        />
                                        <MDBRipple
                                            rippleColor="light"
                                            rippleTag="div"
                                            // className="bg-image rounded hover-zoom hover-overlay "
                                        >

                                            {props.elm.imagesUrls.map((elmx, key) => (
                                                <Image
                                                // width={200}
                                                className="hh-10"
                                                src={elmx}
                                        />
                                                // <img src={baseUrl_back+props.elm} className="hh-10"/>
                                            ))}

                                            {/*<a>*/}
                                            {/*    <div*/}
                                            {/*        onClick={() => setToggler(!toggler)}*/}
                                            {/*        className="mask"*/}
                                            {/*        style={{ backgroundColor: "rgba(251, 251, 251, 0.15)" }}*/}
                                            {/*    ></div>*/}
                                            {/*</a>*/}
                                        </MDBRipple>
                                    </Stack>
                                </MDBCol>
                                <MDBCol md="6">
                                    <h5>{props.elm.name}</h5>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        артикул: {props.elm.article}
                                    </Typography>
                                    <Rating
                                        name="simple-controlled"
                                        precision={0.5}
                                        value={5}
                                        onChange={(event, newValue) => {
                                            setValue(newValue);
                                        }}
                                    />
                                    <div className="mt-1 mb-0 text small">
                                        {/*<Typography variant="body" display="block" gutterBottom>*/}
                                        {/*    Состав: {props.elm.components}*/}
                                        {/*</Typography>*/}
                                        <Typography variant="body" display="block" gutterBottom>
                                            Размер:
                                            <a> {props.elm.Size} </a>

                                        </Typography>
                                        <Typography variant="body" display="block" gutterBottom>
                                            Принт:
                                            <a> {props.elm.Color} </a>

                                        </Typography>

                                        <Typography variant="body" display="block" gutterBottom>
                                            Комплектация:
                                            <a> {props.elm.Complect} </a>

                                        </Typography>


                                            {/*<Typography variant="body" display="block" gutterBottom>*/}
                                            {/*    Доступные размеры:*/}
                                            {/*</Typography>*/}
                                        {/*<div className="mb-2 small">*/}
                                        {/*    <MDBBtnGroup>*/}
                                        {/*        {props.elm.SizesAvailability.map(function (sizes) {*/}
                                        {/*            if (sizes==currsize){*/}
                                        {/*                return (*/}
                                        {/*                    <MDBBtn key={sizes} onClick={() =>SetSize(sizes)} size='sm'  color="light">*/}
                                        {/*                        {sizes}*/}
                                        {/*                    </MDBBtn>*/}
                                        {/*                )*/}
                                        {/*            }*/}
                                        {/*            return (*/}
                                        {/*                <MDBBtn key={sizes} onClick={() => SetSize(sizes)} size='sm' outline color="light">*/}
                                        {/*                    {sizes}*/}
                                        {/*                </MDBBtn>*/}
                                        {/*            )*/}
                                        {/*        })}*/}
                                        {/*    </MDBBtnGroup>*/}
                                        {/*</div>*/}
                                        {/*<Typography variant="body" display="block" gutterBottom>*/}
                                        {/*    <a>Декоративные элементы:</a>{props.elm.decorativeElements.map((elm, key) => (*/}
                                        {/*    <a> {elm}, </a>*/}
                                        {/*))}*/}
                                        {/*</Typography>*/}
                                        {/*<Typography variant="body" display="block" gutterBottom>*/}
                                        {/*    Размер модели на фото: {props.elm.ModelOnPfoto}*/}
                                        {/*</Typography>*/}
                                        {/*<Typography variant="body" display="block" gutterBottom>*/}
                                        {/*    Температура эксплуатации: от {props.elm.minTermal} до +{props.elm.maxTermal}*/}
                                        {/*</Typography>*/}
                                        {/*<Typography variant="body" display="block" gutterBottom>*/}
                                        {/*    <a>Сезонность:</a>{props.elm.Season.map((elm, key) => (*/}
                                        {/*    <a> {elm}, </a>*/}
                                        {/*))}*/}
                                        {/*</Typography>*/}
                                        {/*<Typography variant="body" display="block" gutterBottom>*/}
                                        {/*    {props.elm.description.map((elm, key) => (*/}
                                        {/*    <p> {elm}</p>*/}
                                        {/*))}*/}
                                        {/*</Typography>*/}
                                        <a> {props.elm.Description}</a>
                                        {/*<a> {props.elm.Description}</a>*/}
                                        {/*<a> {props.elm.Description}</a>*/}
                                        {/*<a> {props.elm.Description}</a>*/}

                                    </div>

                                    {/*<p className="text-truncate mb-4 mb-md-0">*/}
                                    {/*    {props.elm.description}*/}
                                    {/*</p>*/}
                                </MDBCol>
                                <MDBCol
                                    md="6"
                                    lg="3"
                                    className="border-sm-start-none border-start"
                                >
                                    <div className="d-flex flex-row align-items-center mb-1">
                                        <h4 className="mb-1 me-1">{props.elm.Price} ₽ㅤ</h4>
                                        <span className="text-danger">
                      <s>{props.elm.PriceBefore} ₽</s>
                    </span>
                                    </div>
                                    <h6 className="text-success">{props.elm.availability_text}</h6>
                                    <div className="d-flex flex-column mt-4">
                                        {(props.elm.ozonLink!="")?(

                                            <Button target={"_blank"} href={props.elm.ozonLink} style={{marginBottom: "5px"}} color="primary" variant="solid">
                                                Купить на Ozon
                                            </Button>
                                        ): (
                                            <></>
                                        )}

                                        {(props.elm.wbLink!="")?(

                                            <Button target={"_blank"} href={props.elm.wbLink} style={{marginBottom: "5px", background: "#a73afd"}}  variant="solid">
                                                Купить на WB
                                            </Button>
                                        ): (
                                            <></>
                                        )}

                                        <MDBBtn onClick={setInCart} outline color={carticonStyle} size="sm">
                                            {carticon}
                                        </MDBBtn>
                                        <MDBBtn onClick={setInFavor} outline color={favoriconStyle} size="sm" className="mt-2">
                                            {favorIcon}
                                        </MDBBtn>
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <LightBoxFs imgs={props.elm.imagesUrls} show={toggler}/>
            {/*<LightBoxFs imgs={sources} show={toggler}/>*/}
        </>
    );
};

export default OneProductDetail;